<template>
  <CmsLayoutResolver />
</template>

<script>
import CmsLayoutResolver from '../../components/cms/CmsLayoutResolver.vue'

export default {
  name: 'TopicPage',
  components: { CmsLayoutResolver }
}
</script>
